@if (notificationInitialized()) {
    <div class="course-notification">
        <div [ngClass]="isUnseen() ? 'is-unseen' : ''" [class.is-fluid]="fluid()" class="course-notification-wrap">
            @if (isShowClose()) {
                <div
                    class="course-notification-close"
                    [attr.aria-label]="'global.action.close' | artemisTranslate"
                    (click)="closeClicked()"
                    #keyboardAction5
                    role="button"
                    tabindex="0"
                    (keydown.enter)="$event.target === $event.currentTarget ? keyboardAction5.click() : undefined"
                    (keydown.space)="$event.target === $event.currentTarget ? $event.preventDefault() : undefined"
                    (keyup.space)="$event.target === $event.currentTarget ? keyboardAction5.click() : undefined"
                >
                    <fa-icon [icon]="faTimes" />
                </div>
            }

            @if (isRedirectToUrl() && notificationUrl()) {
                <a class="course-notification-redirect-link" [routerLink]="notificationUrl().link" [queryParams]="notificationUrl().queryParams"></a>
            }

            <div class="course-notification-background"></div>

            <div class="course-notification-icon-wrap">
                @if (isShowProfilePicture()) {
                    <jhi-profile-picture
                        [isBoxShadow]="true"
                        imageSizeInRem="2.5"
                        fontSizeInRem="1.1"
                        [authorId]="authorId()"
                        [authorName]="authorName()"
                        [imageUrl]="addPublicFilePrefix(authorImageUrl())"
                        [imageBackgroundColor]="isAuthorBot() ? 'transparent' : undefined"
                    />
                } @else {
                    <div class="course-notification-icon">
                        <fa-icon [icon]="faIcon()" />
                    </div>
                }
            </div>

            <div class="course-notification-content-wrap w-full">
                <strong [jhiTranslate]="'artemisApp.courseNotification.' + notificationType() + '.title'" [translateValues]="notificationParameters()"></strong>
                <div class="course-notification-content" [jhiTranslate]="notificationContentKey()" [translateValues]="notificationParameters()"></div>
            </div>

            @if (!isHideTime()) {
                <div class="course-notification-date">
                    <span [jhiTranslate]="notificationTimeTranslationKey()" [translateValues]="notificationTimeTranslationParameters()"></span>
                </div>
            }

            @if (displayTimeInMilliseconds() !== undefined) {
                <div [style.animation-duration]="displayTimeInMilliseconds() + 'ms'" class="course-notification-loading-indicator"></div>
            }
        </div>
    </div>
}
